import { objectsAreEqual } from '../../helpers/utils'
import { ListTradingSecurity, WorkingListTradingOrder } from './types'

export const updateArray = (
  arr: ListTradingSecurity[],
  updates: ListTradingSecurity[]
): ListTradingSecurity[] => {
  const updatedArray = [...arr]
  let changed = false

  updates.forEach((update) => {
    const index = updatedArray.findIndex(
      (originalSecurity) => originalSecurity.id === update.id
    )

    if (index !== -1) {
      /*
        Keep the prior ref (and return the prior array) when nothing changed, so
        market ticks don't churn selectors and re-seed grid editors. New LT reducer
        cases that merge updates should do the same.
      */
      if (!objectsAreEqual(updatedArray[index], update)) {
        updatedArray[index] = update
        changed = true
      }
    } else {
      updatedArray.push(update)
      changed = true
    }
  })

  return changed ? updatedArray : arr
}

export const securityToOrder = (
  security: ListTradingSecurity,
  securityId: number,
  isTemp: boolean
): WorkingListTradingOrder => ({
  securityId,
  cusipOrIsin: security.isin,
  isBid: security.isBid,
  price: security.targetPrice,
  spread: security.targetSpread,
  size: security.remainingInterest,
  selectedOrders: [],
  ordersToCancel: [],
  isTemp
})

/** Maps each identifier to its resolved securityId(s): [] = unrecognized, [id] = resolved, [id1, id2, …] = ambiguous. */
export type IdentifierResolutions = Record<string, number[]>

/** Zip identifiers with the server's securityId arrays into a resolution map. */
export const buildResolutions = (
  identifiers: string[],
  secIds: number[][]
): IdentifierResolutions => {
  const resolutions: IdentifierResolutions = {}
  secIds.forEach((ids, i) => {
    resolutions[identifiers[i]] = ids
  })
  return resolutions
}

/** True when every identifier resolved to exactly one securityId. */
export const allResolved = (resolutions: IdentifierResolutions): boolean =>
  Object.values(resolutions).every((ids) => ids.length === 1)
